module.exports = __webpack_public_path__ + "img/instagram-icon.cbc13d4e.svg";